export const LANGUAGES = [
  { code: 'de', name: 'Deutsch', flag: 'de' },
  { code: 'en', name: 'English', flag: 'gb' },
  { code: 'ru', name: 'Русский', flag: 'ru' },
  { code: 'md', name: 'Moldovenească', flag: 'md' },
  { code: 'ba', name: 'Bosanski', flag: 'ba' },
  { code: 'hr', name: 'Hrvatski', flag: 'hr' },
  { code: 'pl', name: 'Polski', flag: 'pl' },
  { code: 'ro', name: 'Română', flag: 'ro' },
  { code: 'rs', name: 'Srpski', flag: 'rs' }
] as const

export const SUPPORTED_LANG = LANGUAGES.map(l => l.code)
export type SupportedLocale = (typeof LANGUAGES)[number]['code']
